module.exports = __webpack_public_path__ + "static/media/logoOTM.b35269b3.svg";